import { createStyles, Theme } from '@nelnet/unifi-components-react';
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const styles = ({ breakpoints }: Theme) =>
  createStyles({
    header: {
      textTransform: 'uppercase',
      textAlign: 'left',
      margin: '2rem 0 0 0',
      [breakpoints.up('sm')]: {
        margin: '2rem 2rem 0 0',
      },
      [breakpoints.up('lg')]: {
        margin: '5rem 4rem 0 2rem',
      },
    },
    body: {
      padding: '1.5rem 1rem 2rem 0',
      marginRight: 0,
      [breakpoints.up('sm')]: {
        marginRight: '2rem',
      },
      [breakpoints.up('lg')]: {
        margin: '0 4rem 0 2rem',
      },
    },
  });

export default styles;
